var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrowFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 6L0 12V0L6 6Z",
    fill: "#CBD5E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowFilled);
export default __webpack_public_path__ + "static/media/rightArrowFilled.e3b4892fe103639e51c1c13e9ec3cb33.svg";
export { ForwardRef as ReactComponent };